import { Pin } from '@lessonup/pins-shared';
import { hasher } from 'node-object-hash';
import { omitDeepUndefined } from './omit-deep';

export type PinHash = { id: string; hash: string };
export type PinHashes = PinHash[];

export function hashPins(pins: Pin[]): PinHashes {
  return pins.map((pin) => ({ id: pin.id, hash: hash(pin) }));
}

const sortingHasher = hasher({
  sort: true, // ensure consistency of objects with different key order
  coerce: false, // strict value checking (no type coercion)
  alg: 'sha1', // faster implementation and good enough for this use case
  enc: 'base64', // encode the result to make it shorter
});

export const hash = (obj: unknown) => {
  // we need to make sure to omit keys with undefined values before hashing, otherwise the hash will be different
  return sortingHasher.hash(omitDeepUndefined(obj));
};
